<template>
  <div :class="{'loader-wrap':true, 'show':showModal}">
    <div class="loader-box">
      <i class="fa fa-spinner fa-spin"></i>
      <span>{{ modalMessage }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loading-modal',
  props: ['modalMessage', 'showModal']
}
</script>

<style lang="scss" scoped>
.loader-wrap{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0, .5);
  display: none;
  z-index: 12;

  .loader-box{
    position: absolute;
    top: 45%;
    left: 50%;
    width: 400px;
    padding: 25px;
    background: #fff;
    text-align: center;
    border-radius: 6px;
    margin-left: -200px;
    box-shadow: 1px 1px 5px 2px rgba(0,0,0, .3);
    display: none;

    .fa-spin{
      margin-right: 5px;
      color: #333;
    }
    span{
      font-weight: 600;
      color: #443;
      font-size: 16px;
    }
  }
  &.show{
    display: block;

    .loader-box{
      display: block;
      -webkit-animation: slide-down .3s ease-out;
      -moz-animation: slide-down .3s ease-out;
    }
  }
}

@-webkit-keyframes slide-down {
  0% { opacity: 0; -webkit-transform: translateY(100%); }
  100% { opacity: 1; -webkit-transform: translateY(0); }
}
@-moz-keyframes slide-down {
  0% { opacity: 0; -moz-transform: translateY(100%); }
  100% { opacity: 1; -moz-transform: translateY(0); }
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/LoadingModal.vue